import {Injectable} from '@angular/core';
import {BaseService} from '../../base-service';
import {ApiConfiguration} from '../../api-configuration';
import {HttpClient, HttpHeaders, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {StrictHttpResponse} from '../../strict-http-response';
import {QuoteExpiry} from '../../models/quote-expiry';
import {PartialIdResponse} from '../../models/partial-id-response';
import {ValidateClientIdRequest} from '../../models/validate-client-id-request';
import {ValidateClientIdResponse} from '../../models/validate-client-id-response';
import {ValidateClientIdQuoteDetailsResponse} from '../../models/validate-client-id-quote-details-response';

@Injectable({
  providedIn: 'root',
})
export class GapClientService extends BaseService {

  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  checkQuoteValidity(quoteId: string): Observable<QuoteExpiry> {
    return this._checkQuoteValidityResponse(quoteId).pipe(
      map(response => response.body as QuoteExpiry)
    );
  }

  private _checkQuoteValidityResponse(quoteId: string): Observable<StrictHttpResponse<QuoteExpiry>> {
    const url = `${this.rootUrl}/gapClient/checkQuoteValidity/${encodeURIComponent(quoteId)}`;
    return this.http.get<QuoteExpiry>(url, {
      observe: 'response'
    });
  }

  getClientIdNumber(quoteId: string): Observable<PartialIdResponse> {
    return this._getClientIdNumberResponse(quoteId).pipe(
      map(response => response.body as PartialIdResponse)
    );
  }

  private _getClientIdNumberResponse(quoteId: string): Observable<StrictHttpResponse<PartialIdResponse>> {
    const url = `${this.rootUrl}/gapClient/getClientIdNumber/${encodeURIComponent(quoteId)}`;
    return this.http.get<PartialIdResponse>(url, {
      observe: 'response'
    });
  }

  validateClientIdNumberAndRetrieveQuote(validateIdRequest: ValidateClientIdRequest): Observable<ValidateClientIdQuoteDetailsResponse> {
    return this._validateClientIdNumberAndRetrieveQuoteResponse(validateIdRequest).pipe(
      map(response => response.body as ValidateClientIdQuoteDetailsResponse)
    );
  }

  private _validateClientIdNumberAndRetrieveQuoteResponse(validateIdRequest: ValidateClientIdRequest): Observable<HttpResponse<ValidateClientIdQuoteDetailsResponse>> {
    const req = new HttpRequest<ValidateClientIdRequest>(
      'POST',
      `${this.rootUrl}/gapClient/validateClientIdNumberAndRetrieveQuote`,
      validateIdRequest,
      {
        headers: new HttpHeaders(),
        params: this.newParams(),
        responseType: 'json'
      }
    );

    return this.http.request<ValidateClientIdResponse>(req).pipe(
      filter(event => event instanceof HttpResponse),
      map(response => response as HttpResponse<ValidateClientIdQuoteDetailsResponse>)
    );
  }
}
